import "./print.css";
import moment from "moment";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { useTable } from "react-table";
import { selectCompanyAddress } from "../../Redux/profile";

const NewPrintReport = ({ columns, data, title, details, footer, groupBy }) => {
  // Create an instance of the table
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });
  const companyDetails = useSelector(selectCompanyAddress);
  return (
    <div
      id="main2"
      style={{ width: "100%", height: "100%", backgroundColor: "white" }}
    >
      <div
        id="print-component2"
        className={``}
        style={
          window.innerWidth < 600
            ? {
                width: "100%",
                height: "auto",
              overflow: "hidden",
                // marginTop: headerRef?.current?.clientHeight - 10,
              }
            : {
              width: "100%",
              
                height: "auto",
                overflow: "hidden",
                // marginTop: headerRef?.current?.clientHeight - 10,
              }
        }
      >
        <table
          {...getTableProps()}
          style={{
            borderBottom: "1px solid black",
          }}
          className="w-full"
        >
          <thead>
            <tr>
              <td
                style={{
                  height: 10,
                }}
                colSpan={columns.length}
              ></td>
            </tr>
            <tr
              style={{
                borderTop: "1px solid black",
                borderLeft: "1px solid black",
                borderRight: "1px solid black",
              }}
              className=""
            >
              <td
                colSpan={columns.length}
                style={{
                  textAlign: "center",
                  borderBottom: "1px solid #888c89",
                }}
                className="p-0"
              >
                <div className="">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      fontSize: "13px",
                      fontWeight: "600",
                      height: 30,
                    }}
                    className="flex items-center"
                  >
                    {title}
                  </div>
                  {/* Header Section */}

                  <div
                    style={{
                      textAlign: "center",
                      height: 43,
                    }}
                    className="w-full"
                  >
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "15px",
                        height: 20,
                      }}
                      className="uppercase"
                    >
                      {companyDetails?.companyName}
                    </div>
                    <div style={{ fontSize: "10px", height: 20 }}>
                      {companyDetails?.address +
                        ", " +
                        companyDetails?.city +
                        ", " +
                        companyDetails?.state +
                        ", " +
                        companyDetails?.mobile}
                    </div>
                  </div>
                  <div
                    style={{
                      height: 35,
                      borderTop: "1px solid #888c89",
                    }}
                    className="grid grid-cols-3  "
                  >
                    {details.map((d, index) => {
                      return (
                        <div
                          style={{
                            borderRight:
                              index + 1 === details.length
                                ? "0px solid #888c89"
                                : "1px solid #888c89",
                            height: 35,
                            fontSize: 13,
                          }}
                          className="flex items-center  pl-3"
                        >
                          <div
                            style={{
                              height: 25,
                            }}
                            className="flex "
                          >
                            <div className="mr-1 font-semibold">{d.name}</div> :
                            <div className="px-2">{d.value}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Seller Information */}
                </div>
              </td>
            </tr>
            {headerGroups.map((headerGroup, key) => (
              <tr
                key={key}
                style={{ fontSize: "12px", borderLeft: "1px dashed #888c89" }}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column, index) => (
                  <td
                    {...column.getHeaderProps()}
                    className="whitespace-normal overflow-hidden text-center py-2 "
                    style={
                      columns[index].width
                        ? {
                            width: columns[index].width,
                            fontWeight: 500,
                            borderRight: "1px solid #888c89",
                            borderBottom: "1px solid #888c89",
                          }
                        : {
                            flex: columns[index].flex,
                            fontWeight: 500,
                            borderRight: "1px solid #888c89",
                            borderBottom: "1px solid #888c89",
                          }
                    }
                    key={index}
                  >
                    {/* {columns[index].width} */}

                    {columns[index].renderHeader().props.children}
                  </td>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, key) => {
              prepareRow(row);

              return (
                <tr
                  {...row.getRowProps()}
                  style={{
                    borderLeft: "1px dashed #888c89",
                  }}
                  key={key}
                >
                  {row.cells.map((cell, key) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          textAlign:
                            cell.render("Cell").props.cell.column.align,
                          padding: "8px",
                          borderRight: "1px dashed #888c89",
                          borderTop: "1px dashed black",
                          fontSize: "11px",
                          width: cell?.column?.width,
                        }}
                        key={key}
                      >
                        <div
                          style={{
                            textAlign: cell.render("Cell").props.cell.column
                              .align
                              ? cell.render("Cell").props.cell.column.align
                              : "left",
                            width: "100%",
                          }}
                        >
                          {cell.render("Cell").props.cell.column.type === "date"
                            ? moment(
                                cell.render("Cell").props.cell.value
                              ).format("YYYY-MM-DD")
                            : cell.render("Cell").props.cell.value === "0.00" ||
                              cell.render("Cell").props.cell.value === 0 ||
                              cell.render("Cell").props.cell.value === "0"
                            ? " "
                            : cell.column.renderCell
                            ? cell.column.renderCell(
                                cell.render("Cell").props.cell
                              )
                            : cell.render("Cell")}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <div>{footer ? footer : ""}</div>

        <div className="w-full flex justify-between">
          <div
            style={{
              fontSize: "12px",
            }}
            className="flex  pt-2"
          >
            <span style={{ fontSize: "10px", color: "#3b3a39" }}>
              {" "}
              Powered by{" "}
            </span>{" "}
            <span
              style={{ fontSize: "11px", color: "#171716" }}
              className="pl-1"
            >
              genius office{" "}
            </span>
          </div>
          <div className="flex pt-2 items-center ">
            <div
              style={{
                fontSize: "11px",
                color: "#3b3a39",
                fontWeight: "600px",
              }}
            >
              Date :{" "}
            </div>

            <div
              style={{
                fontSize: "10px",
                color: "#3b3a39",
                fontWeight: "500px",
              }}
              className="pl-1"
            >
              {moment().format("YYYY-MM-DD HH:mm ")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPrintReport;
